import { ReactElement } from 'react';

import { MedicalDataAccessAuthorization } from '@dreryk/egabinet-patient-frontend-api';

import { Translate } from '@dreryk/react-common';
import { StrongText, StyledFlex, Text, TextSeparator, TextSeparatorType } from '@dreryk/react-components';

import {
   formatPatientAuthorizationName,
   getPatientAuthorizationIdentifierTypeTranslableText,
   getPatientAuthorizationIdentifierValue,
} from '~libs.desktop.shared.patient-authorization';

import { patientConsentsAndAuthorizationsTranslationKeys } from '../../translations';

import { StyledText } from './PatientAuthorizationsListItemContent.styled';

const t = patientConsentsAndAuthorizationsTranslationKeys.authorizationContent;

type PatientAuthorizationsListItemContentProps = {
   readonly patientAuthorization: MedicalDataAccessAuthorization;
};

export const PatientAuthorizationsListItemContent = (
   props: PatientAuthorizationsListItemContentProps
): ReactElement => {
   return (
      <StyledFlex direction={'column'} gap={7}>
         <StrongText testId={'header'}>
            <Translate>{t.header}</Translate>
         </StrongText>
         {/* TODO: DREGAB-21847 Handle the nesting problem in the TextSeparator component */}
         <div>
            <Text testId={'patientAuthorizationName'}>
               {formatPatientAuthorizationName(props.patientAuthorization)}
            </Text>
            {', '}
            <TextSeparator separator={TextSeparatorType.COLON_SPACE}>
               <Text testId={'identifierType'}>
                  <Translate>
                     {getPatientAuthorizationIdentifierTypeTranslableText(props.patientAuthorization)}
                  </Translate>
               </Text>
               <Text testId={'identifierValue'}>
                  {getPatientAuthorizationIdentifierValue(props.patientAuthorization)}
               </Text>
            </TextSeparator>
         </div>
         <StyledFlex direction={'column'}>
            {props.patientAuthorization.forDocumentation ? (
               <StyledText testId={'documentationAuthorization'}>
                  <Translate>{t.authorizationType.forDocumentation}</Translate>
               </StyledText>
            ) : null}

            {props.patientAuthorization.forInformation ? (
               <StyledText testId={'informationAuthorization'}>
                  <Translate>{t.authorizationType.forInformation}</Translate>
               </StyledText>
            ) : null}
         </StyledFlex>
      </StyledFlex>
   );
};
